/* On-demand explanation only. Signup stays in the existing cart flow. */
if (!customElements.get('loow-first-discount')) {
  customElements.define('loow-first-discount', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const dialog = this.querySelector('dialog');
      const trigger = this.querySelector('[data-discount-open]');
      if (!dialog || !trigger || typeof dialog.showModal !== 'function') return;
      this.initialized = true;
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        if (!dialog.open) dialog.showModal();
      });
      this.querySelectorAll('[data-discount-close]').forEach((button) => {
        button.addEventListener('click', () => dialog.close());
      });
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right ||
            event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      });
      dialog.addEventListener('keydown', (event) => {
        if (event.key !== 'Tab') return;
        const buttons = Array.from(dialog.querySelectorAll('button:not(:disabled)'));
        const first = buttons[0];
        const last = buttons[buttons.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
      dialog.addEventListener('close', () => trigger.focus({ preventScroll: true }));
    }
  });
}
